window.AyneOffers = window.AyneOffers || {
  calculate(items) {
    const count = items.reduce((sum, item) => sum + (item.offer?.eligible ? item.quantity : 0), 0);
    const productCounts = new Map();
    items.forEach(item => {
      if (!item.offer?.sameProduct) return;
      const key = String(item.offer.productId || item.id);
      productCounts.set(key, (productCounts.get(key) || 0) + item.quantity);
    });
    const tier = Math.max(0, Math.min(4, count) - 1);
    const lines = items.map(item => {
      let unitPrice = item.offer?.eligible ? item.offer.prices[tier] : item.price;
      if (item.offer?.sameProduct) {
        const quantity = productCounts.get(String(item.offer.productId || item.id));
        unitPrice = Math.min(unitPrice, item.offer.quantityPrices[Math.max(0, Math.min(3, quantity) - 1)]);
      }
      return {...item, unitPrice, total: unitPrice * item.quantity};
    });
    const original = items.reduce((sum, item) => sum + item.price * item.quantity, 0);
    const total = lines.reduce((sum, item) => sum + item.total, 0);
    return {lines, count, original, total, savings: original - total};
  }
};

window.AyneCart = window.AyneCart || {
  async state(root) {
    const response = await fetch(`${root}cart.js`, {headers: {Accept: 'application/json'}, cache: 'no-store'});
    if (!response.ok) throw new Error();
    const cart = await response.json();
    return JSON.stringify(cart.items.map(item => [item.key, item.quantity]).sort((a, b) => a[0].localeCompare(b[0])));
  },
  recover(root) {
    this.recovering = true;
    window.location.assign(`${root}cart`);
    return null;
  },
  async add(items, trigger, errorMessage) {
    if (this.recovering) return null;
    if (this.pending) throw new Error(errorMessage);
    this.pending = true;
    const root = window.Shopify?.routes?.root || '/';
    try {
      let before;
      try { before = await this.state(root); }
      catch { throw new Error(errorMessage); }
      const sections = [];
      document.documentElement.dispatchEvent(new CustomEvent('cart:grouped-sections', {bubbles: true, detail: {sections}}));
      const requestedSections = [...new Set(sections)].slice(0, 5);
      let response;
      let result;
      try {
        response = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: {'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest'},
          body: JSON.stringify({items, sections: requestedSections, sections_url: window.location.pathname})
        });
        result = await response.json();
      } catch { return this.recover(root); }
      if (!response.ok || result?.status) {
        let after;
        try { after = await this.state(root); }
        catch { return this.recover(root); }
        if (after !== before || response.status >= 500) return this.recover(root);
        throw new Error(typeof result?.description === 'string' ? result.description : errorMessage);
      }
      if (!Array.isArray(result?.items) || !requestedSections.length || requestedSections.some(section => typeof result.sections?.[section] !== 'string')) return this.recover(root);
      try {
        const events = window.MinimogTheme?.pubSubEvents;
        if (!events || !window.MinimogEvents) return this.recover(root);
        window.MinimogEvents.emit(events.cartUpdate, {cart: result, productVariantId: String(items[0].id)});
        document.dispatchEvent(new CustomEvent('product-ajax:added', {detail: {product: result}}));
        const drawer = document.querySelector('m-cart-drawer');
        if (window.MinimogSettings?.enable_cart_drawer && drawer?.open) drawer.open(trigger);
        else return this.recover(root);
      } catch { return this.recover(root); }
      return result;
    } finally {
      this.pending = false;
    }
  }
};

if (!customElements.get('ayne-unit-options')) {
  customElements.define('ayne-unit-options', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.form = document.getElementById(this.dataset.form);
      this.quantity = this.form?.querySelector('[name="quantity"]');
      if (!this.quantity) return;
      this.variants = JSON.parse(this.querySelector('[data-unit-data]').textContent);
      this.variant = this.variants.find(variant => variant.id === Number(this.dataset.variant));
      this.formatter = new Intl.NumberFormat(this.dataset.locale || 'pt-BR', {style: 'currency', currency: this.dataset.currency || 'BRL'});
      const options = {signal: this.controller.signal};
      document.addEventListener('variant:changed', event => {
        const variant = this.variants.find(item => item.id === event.detail?.variant?.id);
        if (!variant) return;
        this.variant = variant;
        this.refresh();
      }, options);
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-units]');
        if (!button) return;
        this.quantity.value = button.dataset.units;
        this.quantity.dispatchEvent(new Event('change', {bubbles: true}));
        this.refresh();
      }, options);
      this.quantity.addEventListener('input', () => this.refresh(), options);
      this.quantity.addEventListener('change', () => this.refresh(), options);
      this.hidden = false;
      this.refresh();
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; }
    refresh() {
      this.querySelectorAll('[data-units]').forEach(button => {
        const count = Number(button.dataset.units);
        const max = this.quantity.max ? Number(this.quantity.max) : Infinity;
        const min = Number(this.quantity.min || 1);
        const step = Number(this.quantity.step || 1);
        const offer = window.AyneOffers.calculate([{...this.variant, quantity: count}]);
        button.querySelector('[data-units-total]').textContent = this.formatter.format(offer.total / 100);
        button.querySelector('[data-units-price]').textContent = this.formatter.format(offer.lines[0].unitPrice / 100);
        button.querySelectorAll('[data-unit-photo]').forEach(photo => {
          if (this.variant.image && photo.dataset.variant !== String(this.variant.id)) {
            photo.removeAttribute('srcset');
            photo.src = this.variant.image;
            photo.dataset.variant = this.variant.id;
          }
        });
        button.disabled = !this.variant.available || count > max || count < min || (count - min) % step !== 0;
        button.setAttribute('aria-pressed', String(count === Number(this.quantity.value)));
      });
    }
  });
}
